import React, { useMemo } from 'react'
import useManageProjectStore from '../../../../../stores/manageProject/useManageProjectStore'
import _ from 'lodash'
// import useProjectHook from '../../../shareLogic/useProjectHook'
import useTranslate from '../../../../../i18n/useTranslate'
import useAppAlertMessageAction from '../../../../../stores/appAlertMessage/appAlertMessageAction'
import path from 'path'
import useLookupService from '../../../../../services/lookup/useLookupService'
import useManageProjectAction from '../../../../../stores/manageProject/useManageProjectAction'

import {
    fileExt as fileExtConst,
    topicForLecturer,
    topicForStudent,
    cerTopic,
} from '../../../../../constants/constants'
import { ResultDocumentTopicLut } from '../../../../../services/lookup/types/responseLookupServiceTypes'
import { uploadFileObjType } from './certificateStampDocumentType'
import useWebService from '../../../../../services/web/useWebService'
import { GetCertificateByIDResultType } from '../../../../../services/web/types/responseWebServiceTypes'
import constSubmittedType from '../../../../../constants/submittedType'
import constSubmittedStatus from '../../../../../constants/submittedStatus'

type UseResultOfConsiderType = any //NoticeAdditionalType
type UploadFileObjType = {
    uploadFileObj: {
        documentTopicID: number

        fileList: {
            documentTopicID: number
            fileID: string
            fileToken: string
            filename: string
            path: string
        }[]

        subTopicPageList?: {
            page: string
            documentTopicID: number
            subtopicID: number
        }[]
    }
}
const useCertificateStampDoc = (props: UseResultOfConsiderType) => {
    const manageProjectStore = useManageProjectStore()
    const callLookup = useLookupService()
    const translate = useTranslate()
    const callWebService = useWebService()

    const appAlertMessageAction = useAppAlertMessageAction()
    const manageProjectAction = useManageProjectAction()

    const projectData = manageProjectStore.projectData
    const [initialUploadFile, setInitialUploadFile] = React.useState<any>()
    const [certificateData, setCertificateData] = React.useState<GetCertificateByIDResultType>()
    const [initialUploadFileCer, setInitialUploadFilecer] = React.useState<any>()
    const hideCertificate = useMemo(() => {
        return (
            !projectData?.isNeedEditForm &&
            projectData?.submitTypeInfo?.value === constSubmittedType.amendmentProject &&
            projectData?.submittedStatusInfo?.value === constSubmittedStatus.complete
        )
    }, [projectData])

    React.useEffect(() => {
        if (projectData && projectData?.irb && projectData?.submitTypeInfo?.value) {
            getDocumentTopicLut(projectData?.irb, projectData?.submitTypeInfo.value)
            getCertificate()
        }
    }, [
        projectData?.projectID ?? null,
        projectData?.submittedID ?? null,
        projectData?.irb ?? null,
        projectData?.submitTypeInfo ?? null,
    ])

    React.useEffect(() => {}, [manageProjectStore.documentTopic])

    React.useEffect(() => {
        if (manageProjectStore.documentTopic) {
            createInitialUploadFileCer()
            createInitialUploadFile()
        }
    }, [
        certificateData?.submittedId ?? null,
        certificateData ?? null,
        manageProjectStore.documentTopic ?? null,
        JSON.stringify(manageProjectStore.projectData?.documentInfo),
        JSON.stringify(manageProjectStore.projectData?.latestDocument),
    ])

    const getDocumentTopicLut = async (irb: number, submitTypeID: number) => {
        if (irb) {
            const res = await callLookup.callDocumentTopicLut(irb, submitTypeID)
            if (res.status === 1) {
                manageProjectAction.setDocumentTopic(res.result)
                filterTopicUpload(res.result)
            } else {
                manageProjectAction.setDocumentTopic([])
            }
        }
    }
    const getCertificate = async () => {
        if (manageProjectStore.projectData) {
            const submittedID = manageProjectStore.projectData.submittedID
            if (submittedID && manageProjectStore.projectData?.stepID > 2) {
                const { result } = await callWebService.getCertificateByID(submittedID)
                setCertificateData(result)
            }
        }
    }

    const filterTopicUpload = (documentTopic: ResultDocumentTopicLut[]) => {
        let docTopic: ResultDocumentTopicLut[] = []
        const researcherTypeID = manageProjectStore?.projectData?.researcherTypeInfo.value
        if (documentTopic) {
            let isDocTopic = documentTopic
            if (researcherTypeID === 1) {
                topicForLecturer.forEach((element) => {
                    docTopic = documentTopic?.filter((item) => {
                        return item.id !== element.id
                    })
                })
            } else {
                topicForStudent.forEach((element) => {
                    docTopic = isDocTopic?.filter((item) => {
                        return item.id !== element.id
                    })
                    isDocTopic = docTopic
                })
            }
            if (docTopic.length > 1) {
                docTopic = docTopic?.map((itm, index: number) => {
                    return { ...itm, no: index + 1, subtopic: [] }
                })
                manageProjectAction.setDocumentTopic(docTopic)
            }
        }
    }

    const handleClickFileStamp = (filePath: string, fileName: string) => {
        const fileExt = path.extname(`${fileName}`)

        if (fileExt !== fileExtConst.pdf) {
            appAlertMessageAction.openAlertMessage({
                title: translate.get('ALERT.TITLE.WARNING'),
                message: translate.get('ALERT.CONTENT.CAN_OPEN_ONLY_PDF'),
            })
        } else {
            window.open(filePath)
        }
    }

    const createInitialUploadFile = () => {
        let uploadFileInit = manageProjectStore.documentTopic?.map((itm: any, idx: number) => {
            return {
                uploadFileObj: {
                    fileList: [],
                    subTopicPageList: [],
                    documentTopicID: itm.id,
                    isDisplay: itm.isDisplay,
                    isRequired: itm.isRequired,
                },
            }
        }) as Array<UploadFileObjType>

        uploadFileInit?.forEach((itm: uploadFileObjType) => {
            certificateData?.documentInfo?.forEach((docInfo: any) => {
                if (docInfo.topicID === itm.uploadFileObj.documentTopicID) {
                    //@ts-ignore
                    itm.uploadFileObj.fileList = docInfo.fileInfo
                    //@ts-ignore
                    itm.uploadFileObj.subTopicPageList = docInfo.subtopic
                }
            })
        })

        //Filter การซ่อนแสดงหัวข้อเอกสาร ถ้าฝั่งสำนักงานให้ซ่อนหัวข้อเอกสาร แต่ว่าหัวข้อนั้นมีไฟล์อยู่ให้ทำการแสดงหัวข้อนั้นออกมา
        if (uploadFileInit?.length > 0) {
            uploadFileInit = uploadFileInit.filter((itm: any) => {
                return itm.uploadFileObj.isDisplay || itm.uploadFileObj.fileList.length !== 0
            })
        }
        setInitialUploadFile(uploadFileInit)
    }
    const createInitialUploadFileCer = () => {
        const uploadFileCerinit: Array<UploadFileObjType> = cerTopic?.map((itm: any, idx: number) => {
            return {
                uploadFileObj: {
                    fileList: [],
                    subTopicPageList: [],
                    documentTopicID: itm.id,
                },
            }
        })
        uploadFileCerinit.forEach((itm: UploadFileObjType) => {
            if (itm.uploadFileObj.documentTopicID === 0) {
                if (certificateData?.certificateInfo?.certificateSignFileName_th) {
                    let fileListTH = {
                        documentTopicID: 0,
                        fileToken: certificateData?.certificateInfo?.certificateSignFileName_th,
                        filename: certificateData?.certificateInfo?.certificateSignFileName_th,
                        fileID: certificateData?.certificateInfo?.certificateSignFileName_th,
                        path: certificateData?.certificateInfo?.cerSign_th,
                    }
                    //@ts-ignore
                    itm.uploadFileObj.fileList.push(fileListTH)
                }
            } else if (itm.uploadFileObj.documentTopicID === 1) {
                if (certificateData?.certificateInfo?.certificateSignFileName_en) {
                    let fileListEN = {
                        documentTopicID: 1,
                        fileToken: certificateData?.certificateInfo?.certificateSignFileName_en,
                        filename: certificateData?.certificateInfo?.certificateSignFileName_en,
                        fileID: certificateData?.certificateInfo?.certificateSignFileName_en,
                        path: certificateData?.certificateInfo?.cerSign_en,
                    }
                    //@ts-ignore
                    itm.uploadFileObj.fileList.push(fileListEN)
                }
            }

            itm.uploadFileObj.subTopicPageList = []
        })
        setInitialUploadFilecer(uploadFileCerinit)
    }
    const getCerTopic = () => {
        let cerTopicList = cerTopic
        if (!certificateData?.certificateInfo?.cerSign_en) {
            cerTopicList = cerTopicList.filter((itm) => itm.id !== 1)
        }
        if (!certificateData?.certificateInfo?.cerSign_th) {
            cerTopicList = cerTopicList.filter((itm) => itm.id !== 0)
        }

        return cerTopicList
    }
    return {
        projectData,
        initialUploadFile,
        initialUploadFileCer,
        hideCertificate,
        cerTopicList: getCerTopic(),
        onClickFileStamp: handleClickFileStamp,
        documentTopicList: manageProjectStore.documentTopic,
    }
}

export default useCertificateStampDoc
